export type ApprovedUserStatement = {
    category: string;
    statement: string;
};

/**
 * DUC categories come from the backend as "General(New)"/"AIAN(New)" or
 * "General(Renewal)"/"AIAN(Renewal)", sometimes combined into one comma-separated
 * string (e.g. "General(New), AIAN(Renewal)"). A first-time (New) DUC is the common
 * case, so its "(New)" marker is dropped; "(Renewal)" is kept since it's the detail
 * worth calling out.
 */
export const formatStatementCategory = (category: string): string => category.replace(/\(New\)/g, '');

/**
 * Flattens a person's per-DUC research use statements into one display string for the grid cell.
 * Most people hold a single active DUC, so the common case shows the statement with no label;
 * only someone holding both an active General and an active AIAN DUC (each with its own
 * statement) gets a category-labeled block per statement.
 */
export const formatResearchUseStatements = (statements?: ApprovedUserStatement[]): string => {
    if (!statements || statements.length === 0) return '';
    if (statements.length === 1) return statements[0].statement ?? '';
    return statements
        .map(({ category, statement }) => `${formatStatementCategory(category)}:\n${statement}`)
        .join('\n\n');
};
